<script setup>
import { ref, onMounted } from 'vue'
import ProductCard from '@/components/productCard.vue'
import { api } from '@/services/api'

const products = ref([])
const loading = ref(true)
const error = ref(null)

onMounted(async () => {
  try {
    products.value = await api.getStor()
  } catch (e) {
    error.value = 'Ürünler yüklenemedi. Lütfen tekrar deneyin.'
  } finally {
    loading.value = false
  }
})
</script>

<template>
  <div class="page">
    <div class="container">
      <header class="category-header">
        <div class="header-content">
          <span class="category-label">KOLEKSİYON</span>
          <h1>Stor Perdeler</h1>
          <div class="accent-line"></div>
        </div>
        <p class="description">Modern ve şık stor perdelerimiz ile evinizi güzelleştirin.</p>
      </header>

      <div v-if="loading" class="state-wrapper">
        <div class="loader"></div>
        <p>Yükleniyor...</p>
      </div>
      <div v-else-if="error" class="state-wrapper error-state">
        <p>{{ error }}</p>
      </div>
      <div v-else-if="products.length === 0" class="state-wrapper">
        <p>Henüz ürün eklenmedi.</p>
      </div>
      <div v-else class="grid">
        <ProductCard
          v-for="p in products"
          :key="p.id"
          :image="p.image_url"
          :title="p.name"
          :color="p.series"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>
.page { background: #ffffff; min-height: 100vh; padding-bottom: 100px; }
.container { max-width: 1400px; margin: auto; padding: 0 40px; }
.category-header { padding: 80px 0 60px; display: flex; flex-direction: column; align-items: flex-start; }
.category-label { color: #2d5a27; font-size: 0.75rem; font-weight: 700; letter-spacing: 4px; margin-bottom: 12px; }
.category-header h1 { font-size: 3rem; font-weight: 800; color: #1a1a1a; margin: 0; line-height: 1; }
.accent-line { width: 60px; height: 3px; background: #2d5a27; margin-top: 15px; }
.description { color: #888; font-size: 1.1rem; max-width: 500px; margin-top: 25px; line-height: 1.6; }
.grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)); column-gap: 30px; row-gap: 60px; }
.state-wrapper { display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 80px 20px; color: #888; gap: 16px; }
.error-state { color: #c0392b; }
.loader { width: 36px; height: 36px; border: 3px solid #f0f0f0; border-top-color: #2d5a27; border-radius: 50%; animation: spin 0.8s linear infinite; }
@keyframes spin { to { transform: rotate(360deg); } }
@media (max-width: 768px) {
  .container { padding: 0 20px; }
  .category-header { padding: 60px 0 40px; }
  .category-header h1 { font-size: 2.2rem; }
  .grid { grid-template-columns: repeat(auto-fill, minmax(160px, 1fr)); gap: 15px; }
}
</style>
